import { useCallback, useRef, useState } from 'react';

export type UseChatInputResult = {
  inputValue: string;
  handleInputChange: (value: string) => void;
  appendToInput: (template: string) => void;
  resetInput: () => void;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
};

export const useChatInput = (): UseChatInputResult => {
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleInputChange = useCallback((value: string) => {
    setInputValue(value);
  }, []);

  const appendToInput = useCallback((template: string) => {
    setInputValue(prev => (prev.length === 0 ? template : `${prev}\n${template}`));
    requestAnimationFrame(() => {
      textareaRef.current?.focus();
    });
  }, []);

  const resetInput = useCallback(() => {
    setInputValue('');
  }, []);

  return { inputValue, handleInputChange, appendToInput, resetInput, textareaRef };
};
